<div [class.sticky-element-background]="isMediumOpen || isLargeOpen"></div>
<div class="sticky-element" [class.overlay-open]="isMediumOpen || isLargeOpen">
  <section
    class="compare__footer flex align--center justify--center"
    *ngIf="!isLargeOpen"
  >
    <app-floating-button
      [offers]="comparisonsSelected"
      (clicked)="onCompareModelsClick($event)"
      *ngIf="!isMediumOpen; else compare"
      [@fadeInOut]
    >
    </app-floating-button>

    <ng-template #compare>
      <app-overlay-medium
        [@fadeInOut]
        [comparisons]="comparisons"
        (closed)="toggleMediumOverlay()"
        (removed)="onRemoveMediumCard($event)"
        (compare)="onCompareClick()"
      ></app-overlay-medium>
    </ng-template>
  </section>
  <app-overlay-large
    [@fadeInOut]
    *ngIf="isLargeOpen"
    (closed)="toggleLargeOverlay()"
    (selected)="onComparisonSelectClick($event)"
    (removed)="onRemoveLargeCard($event)"
    [comparisons]="comparisons"
  >
  </app-overlay-large>
</div>
